import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateUsageUser } from "../services/update-usage-user";

export function useUpdateUsageUser() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      source_id,
      user_id,
    }: {
      source_id: string;
      user_id: string | null;
    }) => updateUsageUser(source_id, user_id ?? null),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["usage"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      toast({
        title: "Success",
        description: "User ID updated successfully",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to update user ID",
        variant: "destructive",
      });
    },
  });
}
